import PresetService from '../../../src/dashboard/PresetService';
import WidgetService from '../../../src/dashboard/WidgetService.js';
import Widget from '../../../src/dashboard/Widget.jsx';
import Utility from '../../../src/core/Utility.js';
import Translate from '../../../src/core/Translate.js';

class DashboardContainerController {
	constructor($element, $scope, $location, $timeout, $translate, $filter, serviceMessageBus, serviceSession, Fullscreen, serviceAuth, USER_LEVELS, eventSender, serviceNotification) {
		this.msgbus = new Araqne.MessageBusService(null);
		serviceMessageBus.setMessageBus(this.msgbus);
		Translate.setLocale(serviceSession.getUserLanguage());

		// old code.
		// eventSender.dashboard.$event.on('unload', this.destroyAllWidget.bind(this));
		// eventSender.dashboard.$event.on('suspend', () => { try { this.currentInner.suspend(); } catch(e) { } });
		eventSender.dashboard.$event.on('unload',  () => { 
			if(!!this.currentInner){
				this.currentInner.suspend();
			}
		});
		eventSender.dashboard.$event.on('suspend', () => { 
			if(!!this.currentInner){
				this.currentInner.suspend();
			}
		});
		eventSender.dashboard.$event.on('resume', () => {
			var mainContainer = this.el.find('.toolbar-inner').width();
			var leftBtn = this.el.find('.pull-left').width();
			var rightBtn = this.el.find('.pull-right').width();

			var titleWidth = mainContainer - (leftBtn + rightBtn);
			this.el.find('.brandpreset').css({'width': titleWidth , 'padding-left': '60px'}); 
			WidgetService.init(this.msgbus, () => {
				if(!!this.currentInner){
					this.currentInner.resume(); 
				}
			}); 

		});

		this.serviceNotification = serviceNotification;
		this.el = $element;
		this.currentInner;
		this.currentParent;
		this.scope = $scope;
		this.$timeout = $timeout;
		this.$location = $location;
		this.$filter = $filter;
		this.$translate = $translate;
		this.serviceSession = serviceSession;
		this.serviceFullscreen = Fullscreen;
		this.eventSender = eventSender;
		this.presets = {};

		this.appGrant = false;
		this.isAppRun = false;
		this.isLoading = true;
		this.isExpanded = false;
		this.isEditMode = true;

		PresetService.setPresetInfo({'theme': 'white'});
		this.serviceAuth = serviceAuth;
		this.isAuthorized = this.serviceAuth.isAuthorized;
		this.USER_LEVELS = USER_LEVELS;
		this.currentUser = this.serviceSession.whoAmI();
		this.belongsToWriteGrantGroup = false;
		this.belongsToWriteGrant = false;
		
		setInterval(() => {
			$scope.$digest();
		},500)

		
		if(Araqne.AppService && Araqne.AppService.currentApp){
			this.isAppRun = true;
			this.appGrant = Araqne.AppService.currentGrant.write;
		}
		this.initAuth();
		this.initContainerTemplate();
		WidgetService.init(this.msgbus, this.initTemplate.bind(this));


		this.scope.$on('DashboardController:updateParentPreset', this.onUpdateParentPreset.bind(this));
		this.scope.$on('DashboardController:onPresetChanged', this.onPresetChanged.bind(this));
		this.scope.$on('DashboardController:onDrillDownChanged', this.onDrillDownChanged.bind(this));
		this.scope.$on('DashboardContainerController:onParentPresetChanged', this.onParentPresetChanged.bind(this));
		this.scope.$on('DashboardController:onFilterChange', () => {
			this.$timeout(() => {
				this.scope.$apply();
			});
		});
		this.scope.$on('AddNewWidgetController:onSubmit', this.addNewWidget.bind(this));
		this.scope.$on('AddNewWidgetController:onClose', () => { });
		this.scope.$on('DashboardController:onInfoClick', this.onInfoClick.bind(this));
		this.scope.$on('DashboardController:onFailClick', this.onFailClick.bind(this));
		this.scope.$on('DashboardContainerController:onDataSourceChange', this.onDataSourceChange.bind(this));
		this.scope.$on('DashboardContainerController:onPresetConfigChanged', (e, presetConfig) => {
			//this.setTheme(preset.theme, true); // 이부분에선 저장을 하면 안됨. 아래의 이벤트 handler에서 setPreset을 할 것이기 때문.
			this.setDashboardFontSize(presetConfig.presetTitleFontSize);
			this.scope.$broadcast('PresetConfigController:onPresetConfigChanged', presetConfig);
		})
		this.scope.$watch('vm.isExpanded', this.isExpandedChanged.bind(this));
		this.scope.$watch('vm.isEditMode', this.isEditChanged.bind(this));

		this.scope.$on('DashboardContainerController:onRefreshDashboard', this.onRefresh.bind(this));

		this.scope.$on('DashboardController:notify', (e, obj)=>{
			this.serviceNotification.notify(obj);
		})

	}

	snapShot(){
		console.log("this.currentInner", this.currentInner);
		this.currentInner.takeAllSnapShot();
	}

	onDrillDownChanged(isDrillDown) {
		this.scope.$apply();
	}
	
	initAuth() {
		/*
			this.isWritable is used for both widget loading and making.
			as this.currentParent.owner is undefined only when making currentParent(parent preset),
			added if clause that returns always true when owner is undefined 
		*/
			this.isWritable = () => {
				if(!this.isEditMode){
					return false;
				}


				if(this.appGrant){
					return true;
				}

				if(!this.currentParent) {
					
					return false;
				}
	
				if(!this.currentParent.owner){
					return true;
				}
	
				return (this.currentUser === this.currentParent.owner)
					|| this.isAuthorized(this.USER_LEVELS.admin)
					|| this.belongsToWriteGrantGroup
					|| this.belongsToWriteGrant;
			}
	
			this.isGrantable = () => {
				if(!this.currentParent) {
					return false;
				}

				return (this.currentUser === this.currentParent.owner)
					|| this.isAuthorized(this.USER_LEVELS.admin)
					|| this.appGrant;
			}
	}

	initTemplate() {
		this.src = '/dashboard/view.dashboard.html';
			
		this.srcNewWidget = '/package/system/dashboard/view.AddNewWidget.html';
		this.initEditTemplate();

		this.scope.$apply();
	}

	initEditTemplate() {
		this.srcPresetShare = '/package/system/dashboard/view.PresetShareReadonly.html';
		this.srcQueryFailedModal = '/package/system/dashboard/view.showQueryFailedModal.html';
		if(this.isWritable()) {
			this.srcEditWidget = '/package/system/dashboard/view.EditWidget.html';
			if(this.isGrantable()){ // member인 경우 write 권한이 있어도 grant 할 수 없기떄문에 share하려고 시도시 read-only와 동일한 화면을 보여줘야한다.
				this.srcPresetShare = '/package/system/dashboard/view.PresetShare.html';
			}
			this.srcPresetConfig = '/package/system/dashboard/view.PresetConfig.html';
		}
		else {
			this.srcEditWidget = '/package/system/dashboard/view.ViewWidget.html';
		}
	}

	initContainerTemplate() {
		this.srcContainerTemplate = '/package/system/dashboard/view.DashboardContainer.html';
	}


	setLatestPreset() {
		this.serviceSession.setUserSettings({'dashboard_preset': this.currentParent.guid});
	}

	getLatestPreset(presetList) {
		var latestPresetGuid = this.serviceSession.getUserSettings('dashboard_preset');
		var found = [];
		if(latestPresetGuid == null) { // latestPresetGuid이 없는경우 autosave 생성,없는경우는 삭제되었거나 공유해제가 된경우
			found = presetList.filter(preset => {
				return preset.guid.indexOf("autosave") === 0;
			});
			if(found.length > 0){
				PresetService.getPreset(this.msgbus, found[0].guid)
				.onSuccess(resp => {
					this.loadPreset(resp.preset);
					console.log("latest preset is null =", resp.preset);
				});
				return;
			}
		} else { // latestPresetGUID가 있으면 presetlist중에 해당 guid가 있는지
			found = presetList.filter(preset => {
				return preset.guid === latestPresetGuid;
			});
			//issue 2753 referenced 2757, found를 찾았다면 여기서 전부 확인하고 끝내야한다.
			if(found.length > 0) {
				PresetService.getPreset(this.msgbus, found[0].guid)
				.onSuccess(resp => {
					this.loadPreset(resp.preset, true);
					console.log("latest preset found =", resp.preset);
				});
				return;
			}
		}
		// issue 2753 referenced 2757, found가 없을경우에만 아래를 타야한다.
		if(presetList.length > 0){
			PresetService.getPreset(this.msgbus, presetList[0].guid)
			.onSuccess(resp => {
				this.loadPreset(resp.preset);
				console.log("latest preset not found =", resp.preset);
			});
		} else { // issue 2753 referenced 2757, 프리셋을 공유했다가 해제했을지 이루틴을 타서 더미 프리셋이 자꾸 생성됨.
			// 이부분을 탔다는것은 preset이 현재 한개도 없다는 것.
			let presetname = this.$filter('translate')('$S_str_NewPreset');

			PresetService.createNew(this.msgbus, presetname, this.scope)
			.onSuccess(parent => {
				this.loadPreset(parent);
			});
		}
	}

	onPresetChanged(e, preset) {
		console.log('onPresetpChanged' , preset);

		this.currentInner = preset;
		this.isLoading = false;

		if(!!this.currentParent.state.style) {
			this.setTheme(this.currentParent.state.style.theme || 'white', true);
		}
		else {
			this.setTheme('white', true);
		}

		this.scope.$broadcast('DashboardController:afterPresetChanged', this.currentParent.state.style);

	}

	loadPreset(preset, skipSetLatestPreset) {
		this.updateSecurityconfig( preset, () => {	
			this.currentParent = preset;
			this.initEditTemplate();
			this.scope.$broadcast('DashboardController:setPreset', preset, {
				isReadOnly: !this.isWritable()
			});
			if(!!this.currentParent.state.style){
				this.setDashboardFontSize(this.currentParent.state.style.presetTitleFontSize || 20);
			}
			if(!skipSetLatestPreset) {
				this.setLatestPreset();
			}
		});
	}
	
	updateSecurityconfig(preset, callback){
		if(!!preset ){
			if(!!preset.owner) {//if(Array.isArray(preset.write_grants)){, 방금 만든 새 프리셋인경우 owner가 없음고, write_grants가 undefined.
				this.belongsToWriteGrant = preset.write_grants.some( (item) => {return item == this.currentUser;})
				this.serviceAuth.getMySecurityGroups().success( (response) => {
					 var guidList = response.body.security_groups.map( (item) => { return item.guid; });
					 this.belongsToWriteGrantGroup = preset.write_grant_groups.some( (group) => {return guidList.indexOf(group) !== -1;});
					 callback();
				});
			} else {
				this.belongsToWriteGrant = false;
				this.belongsToWriteGrantGroup = false;
				callback();
			}
		}
	}

	newParentPreset() {
		var presetname = prompt(Translate.get('$S_msg_NewPresetName'));
		if(presetname == undefined || presetname === '') return;

		PresetService.createNew(this.msgbus, presetname, this.scope)
		.onSuccess(parent => {
			this.loadPreset(parent);
		});
	}

	saveParentPresetAs() {
		var newname = prompt(Translate.get('$S_msg_SavePresetAs'));
		if(newname == undefined || newname === '') return;

		PresetService.clonePreset(this.msgbus, this.currentParent, newname, (clonedParentPresetGUID) => {
			console.log('saveParentPreset callback');
			PresetService.getPreset(this.msgbus, clonedParentPresetGUID)
			.onSuccess(resp => {
				this.loadPreset(resp.preset);
				this.scope.$broadcast('PresetListController:updatePresetList');
			});
		});
	}

	removeParentPreset() {
		console.log("remove parent preset guid= " , this.currentParent.guid)
		PresetService.removePreset(this.msgbus, this.currentParent.guid)
		.onSuccess(() => {
			//this.scope.$broadcast('PresetListController:updatePresetList');
			this.scope.$broadcast('PresetListController:selectLastPreset');
			this.el.find('.mdlRemovePreset')[0].hideDialog();
		});
	}

	copyPresetUrl() {
		$('.mdlMemberPresetShareSuccess .url-msg').copyNodeText();
		notify('success', Translate.get('$S_msg_CopyInfoSuccess'), true);
	}

	onLoadDashboard() {
		this.scope.$broadcast('DashboardController:setPreset', this.currentParent, {
			isReadOnly: !this.isWritable()
		});

	}

	openManageDataSourceModal() {
		this.datasource = null;
		this.el.find('.mdlManageDataSource')[0].showDialog();
	}

	openNewWidgetModal() {
		this.el.find('.mdlAddNewWidget')[0].showDialog();
		this.scope.$broadcast('DashboardContainerController:getCurrentPreset', this.currentInner);
	}

	openSharePresetModal() {
		if(this.isGrantable()) {
			this.scope.$broadcast('PresetShareController:setPreset', this.currentParent);
		}
		else {
			this.scope.$broadcast('PresetShareController:setPresetInfo', this.currentParent);
		}
	}

	onParentPresetChanged(e, parent) {
		this.currentParent = parent;
		this.scope.$broadcast('DashboardController:onParentPresetChanged', this.currentParent);
		console.warn('------- onParentPresetChanged -------', this.currentParent);
	}

	onUpdateParentPreset(e, parent){
		this.currentParent = parent;
		console.warn('------- synchronize data from dashboardcontroller -------', this.currentParent);
	}

	openPresetConfigModal() {
		this.el.find('.mdlPresetConfig')[0].showDialog();
		this.scope.$broadcast('PresetConfigController:setPreset', this.currentParent);
	}

	onRefresh(e) {
		this.scope.$broadcast('DashboardController:onRefreshPreset');
	}

	exportDashboard() {
		if (!this.currentParent.guid) return;
		PresetService.exportWallPreset(this.msgbus, this.currentParent.guid)
	}

	openRemoveParentModal() {
		PresetService.getParentPresets(this.msgbus)
		.onSuccess(presets => {
			if(presets.length === 1) {
				this.serviceNotification.notify({
					type: 'error',
					title: Translate.get('$S_str_RemovePreset'),
					msg: Translate.get('$S_msg_AtLeastOnePresetRequired'),
					autohide: true
				});
			}
			else {
				this.el.find('.mdlRemovePreset')[0].showDialog();
			}
		})
	}

	getCurrentApiKey() {
		return this.msgbus.send('com.logpresso.core.msgbus.ApikeyPlugin.getCurrentApiKey', {});
	}

	openShareEmbedPresetWizard() {
		if(this.isAuthorized(this.USER_LEVELS.admin)) {
			this.eventSender.dashboard.openShareEmbedPresetWizard(this.currentParent);
		}else {
			this.getCurrentApiKey().onSuccess(resp => {
				var currentApiKey = resp.apikey;
				if(currentApiKey === null) {
					this.openMemberShareEmbedPresetModal('no-apikey');
				}else {
					var currentUserLoginName = this.currentUser;

					if(this.currentParent.owner === currentUserLoginName) {
						this.openMemberShareEmbedPresetModal('success', currentApiKey);
					}else {

						if (this.appGrant) {
							this.openMemberShareEmbedPresetModal('success', currentApiKey);
						} else if(this.currentParent.read_grants !== undefined) {
							var isExist = this.currentParent.read_grants.some(function(grantedUser) {
								return grantedUser === currentUserLoginName;
							});

							if(!isExist) {
								this.openMemberShareEmbedPresetModal('account-not-granted');
							}else{
								this.openMemberShareEmbedPresetModal('success', currentApiKey);
							}
						} else{
							this.openMemberShareEmbedPresetModal('account-not-granted');
						}
					}
				}
			}).onFailure(openError);
		}
	}

	openMemberShareEmbedPresetModal(type, apikey) {
		var protocol = this.$location.protocol() + '://',
			host = this.$location.host(),
			port = this.$location.port() === undefined ? '' : ':' + this.$location.port(),
			path = '/logpresso/dashboard/',
			presetGUID = this.currentParent.guid,
			apikeyString = '?apikey=',
			url = undefined;

		url = protocol + host + port + path + presetGUID + apikeyString + apikey;

		this.scope.shareEmbedPresetModalType = type;
		this.scope.shareEmbedPresetUrl = (type === 'success' ? url : undefined);
		this.scope.$apply();

		if(type === 'success') {
			$('.mdlMemberPresetShareSuccess')[0].showDialog();
		}else{
			$('.mdlMemberPresetShareFailed')[0].showDialog();
		}
	}

	onInfoClick(e, widget) {
		console.log(widget);
		this.el.find('.mdlProperty')[0].showDialog();
		this.scope.$broadcast('DashboardContainerController:getCurrentWidget', widget, this.currentInner);
	}

	onFailClick(e, brokenMessage) {
		console.log(brokenMessage);
		this.brokenMessage = brokenMessage;
		this.el.find('.mdlQueryFailed')[0].showDialog();
		this.scope.$apply();
	}

	renamePreset(newname) {
		this.$timeout(() => {
			console.warn('------- saved!! -------', this.currentParent);
			PresetService.setPreset(this.msgbus, this.currentParent)
			.onSuccess(() => {
				this.scope.$broadcast('PresetListController:updatePresetList');
			});
		});

	}

	onDataSourceChange(e, model) {
		var keys = Object.keys(model.sources);
		var list = keys.map(key => {
			var obj = model.sources[key];
			return {
				name: obj.name,
				guid: obj.guid,
				query: obj.query
			};
		});

		this.scope.$broadcast('DashboardController:updateDataSource', list);
	}

	addNewWidget(e, widget, store) {

		var guid = Utility.generateType2();
		var newbie = LayoutEngine.createBox({
			'w': 100,
			'guid': guid
		}, false,
		{
			'onDrag': (box, em, ed) => {

			},
			'onDrop': (box, event, targetDockId) => {
			},
			'onAppend': (box, event, targetDockId) => {
				this.currentInner.addComplete();
				//위젯 생성하고 Arrow에 Drop할때 불리는 함수.
				this.currentInner.resizeWidgets.call(this.currentInner);
				this.currentInner.savePreset();
			},
			'onModify': Utility.debounce((box) => {
			}, 200),
			'onResize': (row, box) => {
			}
		});

		var dragMsg = this.$filter('translate')('$S_msg_WidgetDrag');
		var newdivHTML = '<div class="newbie"></div>';
		var newdivHelp = angular.element('<div class="tooltip in top" style="margin-top: -42px;">\
				<div class="tooltip-arrow"></div>\
				<div class="tooltip-inner" style="max-width: 400px">' + dragMsg + '</div>\
			</div>');
		var newdiv = $(newdivHTML).appendTo('.dockpanel.tab-content');
		var isSplitInsert = false;
		newbie.on('splitInsert', function() {
			newbie.el.find('.handler').off('mousedown.help');
			isSplitInsert = true;
		});

		newbie.el.find('.handler').on('mousedown.help', function() {
			$(document).on('mouseup.help', function(eu) {
				if(isSplitInsert) {
					newdiv.remove();
				}
				$(document).off('mouseup.help');
			})
		});

		newbie.resizerH.hide();
		newbie.appendTo(newdiv, true);
		newdivHelp.prependTo(newdiv.find('.k-d-col'));


		this.currentInner.addWidget(Object.assign(widget, {guid: guid}));
	}

	// added for resizing font of dashboardController.
	setDashboardFontSize(size) {
		this.el.find('.brandpreset').css('font-size' , size);
	}
	
	
	setTheme(theme, notSave = false) {
		if(theme === 'black') {
			this.el.find('.toolbar-main').addClass('dark');
		}
		else {
			this.el.find('.toolbar-main').removeClass('dark');
		}
		
		if(!!this.currentParent.state.style) {
			this.currentParent.state.style.theme = theme;
		}
		else {
			this.currentParent.state.style = {'theme': theme};
		}//dashboardcontroller의 setTheme 이벤트 핸들러에도 같은 루틴을 넣음.

		this.scope.$broadcast('DashboardController:setTheme', theme, notSave);
	}
	
	isExpandedChanged(newval) {
		if(newval) {
			$('#view-dashboard').addClass('fullscreen');
			$('#view-menu').addClass('fullscreen');
			
			if(!this.serviceFullscreen.isEnabled()) {
				this.serviceFullscreen.all();
			}
		}
		else {
			$('#view-dashboard').removeClass('fullscreen');
			$('#view-menu').removeClass('fullscreen');
			
			if(this.serviceFullscreen.isEnabled()) {
				this.serviceFullscreen.cancel();
			}
		}
	}
	
	isEditChanged(newval) {
		this.loadPreset(this.currentParent);
	}

	resetFilter() {
		this.currentInner.resetFilter();
	}

	destroyAllWidget() {
		this.scope.$broadcast('DashboardController:destroy');
	}

}

export default DashboardContainerController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/DashboardContainerController.js